import {
  Activity,
  AlertTriangle,
  BookOpen,
  Calendar,
  CalendarDays,
  ChevronRight,
  Circle,
  ClipboardList,
  Droplets,
  FileText,
  FlaskConical,
  Footprints,
  Gauge,
  Heart,
  HeartPulse,
  Home,
  Info,
  LineChart,
  Microscope,
  Moon,
  PhoneCall,
  Pill,
  Scale,
  Stethoscope,
  Syringe,
  Thermometer,
  ThermometerSun,
  Users,
  Utensils,
  Wind,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';

/**
 * Registro explícito de iconos.
 *
 * Deliberadamente NO se hace `import * as icons from 'lucide-react'`: eso mete
 * las ~1500 figuras de la librería en el bundle y lo infla medio megabyte, que
 * en el teléfono de un paciente con mala señal se paga en segundos de espera.
 *
 * Como el nombre del icono viene de la base —lo elige la pharma al configurar un
 * tracker o un item de menú—, hace falta una búsqueda en runtime; pero se hace
 * contra esta lista curada, que además es la que ofrece el selector de la
 * consola. Para sumar uno nuevo: importarlo arriba y agregarlo acá.
 */
const REGISTRY: Record<string, LucideIcon> = {
  activity: Activity,
  'alert-triangle': AlertTriangle,
  'book-open': BookOpen,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  'chevron-right': ChevronRight,
  circle: Circle,
  'clipboard-list': ClipboardList,
  droplets: Droplets,
  'file-text': FileText,
  'flask-conical': FlaskConical,
  footprints: Footprints,
  gauge: Gauge,
  heart: Heart,
  'heart-pulse': HeartPulse,
  home: Home,
  info: Info,
  'line-chart': LineChart,
  microscope: Microscope,
  moon: Moon,
  'phone-call': PhoneCall,
  pill: Pill,
  scale: Scale,
  stethoscope: Stethoscope,
  syringe: Syringe,
  thermometer: Thermometer,
  'thermometer-sun': ThermometerSun,
  users: Users,
  utensils: Utensils,
  wind: Wind,
};

/**
 * Icono por nombre. Como el nombre es dato y no código, uno inexistente no puede
 * romper la pantalla: cae en un círculo neutro.
 */
export function Icon({ name, ...props }: { name: string | null | undefined } & LucideProps) {
  const Component = REGISTRY[name ?? ''] ?? Circle;
  return <Component aria-hidden {...props} />;
}

/** Opciones del selector de iconos de la consola. */
export const ICON_OPTIONS = Object.keys(REGISTRY).sort();
